import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';

import slider1EnWeb    from '../../assets/site-assets/home/header-slider/slider-1-en-web.webp';
import slider1EnMobile from '../../assets/site-assets/home/header-slider/slider-1-en-mobile.webp';
import slider1ArWeb    from '../../assets/site-assets/home/header-slider/slider-1-ar-web.webp';
import slider1ArMobile from '../../assets/site-assets/home/header-slider/slider-1-ar-mobile.webp';

import slider2EnWeb    from '../../assets/site-assets/home/header-slider/slider-2-en-web.webp';
import slider2EnMobile from '../../assets/site-assets/home/header-slider/slider-2-en-mobile.webp';
import slider2ArWeb    from '../../assets/site-assets/home/header-slider/slider-2-ar-web.webp';
import slider2ArMobile from '../../assets/site-assets/home/header-slider/slider-2-ar-mobile.webp';

import slider3EnWeb    from '../../assets/site-assets/home/header-slider/slider-3-en-web.webp';
import slider3EnMobile from '../../assets/site-assets/home/header-slider/slider-3-en-mobile.webp';
import slider3ArWeb    from '../../assets/site-assets/home/header-slider/slider-3-ar-web.webp';
import slider3ArMobile from '../../assets/site-assets/home/header-slider/slider-3-ar-mobile.webp';

import slider4EnWeb    from '../../assets/site-assets/home/header-slider/slider-4-en-web.jpg';
import slider4EnMobile from '../../assets/site-assets/home/header-slider/slider-4-en-mobile.png';
import slider4ArWeb    from '../../assets/site-assets/home/header-slider/slider-4-ar-web.jpg';
import slider4ArMobile from '../../assets/site-assets/home/header-slider/slider-4-ar-mobile.png';

import { ReactComponent as SliderVector } from '../../assets/site-assets/home/slider-vector.svg';
import { ReactComponent as SliderStar }   from '../../assets/site-assets/home/slider-star.svg';

import './HeroSlider.scss';

const slides = [
  { en: { web: slider1EnWeb, mobile: slider1EnMobile }, ar: { web: slider1ArWeb, mobile: slider1ArMobile } },
  { en: { web: slider2EnWeb, mobile: slider2EnMobile }, ar: { web: slider2ArWeb, mobile: slider2ArMobile } },
  { en: { web: slider3EnWeb, mobile: slider3EnMobile }, ar: { web: slider3ArWeb, mobile: slider3ArMobile } },
  { en: { web: slider4EnWeb, mobile: slider4EnMobile }, ar: { web: slider4ArWeb, mobile: slider4ArMobile } },
];

const HeroSlider = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'ar' ? 'ar' : 'en';

  return (
    <section className="hero-slider">
      <button className="hero-slider__arrow hero-slider__arrow--prev" aria-label={t('heroSlider.previousSlide')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={i18n.language === 'ar' ? { transform: 'scaleX(-1)' } : undefined}>
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <button className="hero-slider__arrow hero-slider__arrow--next" aria-label={t('heroSlider.nextSlide')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={i18n.language === 'ar' ? { transform: 'scaleX(-1)' } : undefined}>
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>

      <div className="hero-slider__pagination" />

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        loop
        autoplay={{ delay: 5500, disableOnInteraction: false }}
        speed={750}
        navigation={{
          prevEl: '.hero-slider__arrow--prev',
          nextEl: '.hero-slider__arrow--next',
        }}
        pagination={{
          el: '.hero-slider__pagination',
          clickable: true,
          bulletClass: 'hero-slider__bullet',
          bulletActiveClass: 'hero-slider__bullet--active',
        }}
        key={i18n.language}
        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
        className="hero-slider__swiper"
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <div className="hero-slider__slide">
              <picture>
                <source media="(max-width: 768px)" srcSet={slide[lang].mobile} />
                <img src={slide[lang].web} alt={t(`heroSlider.slides.${idx}.alt`)} />
              </picture>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="hero-slider__float hero-slider__float--star">
        <SliderStar />
      </div>
      <div className="hero-slider__float hero-slider__float--vector">
        <SliderVector />
      </div>
    </section>
  );
};

export default HeroSlider;
